import { useContext, useState, useRef, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import LanguageContext from "./LanguageContext";

function NavFooter({ children }) {
    const { lang, setLang, t } = useContext(LanguageContext);
    const [menuOpen, setMenuOpen] = useState(false);

    const [langOpen, setLangOpen] = useState(false);
    const langRef = useRef(null);

    useEffect(() => {
        const onClickOutside = (e) => {
            if (langRef.current && !langRef.current.contains(e.target)) {
                setLangOpen(false);
            }
        };

        const onEsc = (e) => {
            if (e.key === "Escape") {
                setLangOpen(false);
            }
        };
        document.addEventListener("keydown", onEsc);
        window.addEventListener("mousedown", onClickOutside);
        return () => {
            document.removeEventListener("keydown", onEsc);
            document.removeEventListener("mousedown", onClickOutside);
        }
    }, []);

    const currentFlag = lang === "zh" ? "🇨🇳" : "🇬🇧";

    const selectLang = (next) => {
        setLang(next);
        setLangOpen(false);
        setMenuOpen(false);
    };

    return (
        <div className="app">
            {/* Navbar */}
            <header className="header">
                <div className="nav-row">
                    <Link to="/" className="nav-brand-link">
                        <div className="brand">
                            <div className="logo-circle">愈</div>
                            <div>
                                <div className="brand-title">{t.brandTitle}</div>
                                <div className="brand-subtitle">{t.brandSubtitle}</div>
                            </div>
                        </div>
                    </Link>

                    <div className="nav-actions">
                        <div className="lang-dropdown" ref={langRef}>
                            <button
                                type="button"
                                className="lang-toggle"
                                onClick={() => setLangOpen((v) => !v)}
                                aria-haspopup="menu"
                                aria-expanded={langOpen}
                                aria-label={lang === "zh" ? "选择语言" : "Select language"}
                            >
                                <span className="lang-flag" aria-hidden="true">
                                    {currentFlag}
                                </span>
                                <span className="lang-text">{lang === "zh" ? "中文" : "EN"}</span>
                                <span className="lang-caret" aria-hidden="true">▾</span>
                            </button>

                            {langOpen && (
                                <div className="lang-menu" role="menu">
                                    <button
                                        type="button"
                                        className={"lang-item" + (lang === "en" ? " active" : "")}
                                        onClick={() => selectLang("en")}
                                        role="menuitem"
                                    >
                                        <span className="lang-flag" aria-hidden="true">🇬🇧</span>
                                        <span>English</span>
                                    </button>

                                    <button
                                        type="button"
                                        className={"lang-item" + (lang === "zh" ? " active" : "")}
                                        onClick={() => selectLang("zh")}
                                        role="menuitem"
                                    >
                                        <span className="lang-flag" aria-hidden="true">🇨🇳</span>
                                        <span>中文</span>
                                    </button>
                                </div>
                            )}
                        </div>

                        <button
                            className="menu-toggle"
                            onClick={() => setMenuOpen(!menuOpen)}
                            aria-label="menu"
                        >
                            ☰
                        </button>
                    </div>
                </div>

                <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
                    <NavLink to="/" onClick={() => setMenuOpen(false)} className={({ isActive }) =>
                        'nav-link' + (isActive ? " active" : "")}
                    >
                        {t.navHome}
                    </NavLink>

                    <NavLink to="/services" onClick={() => setMenuOpen(false)} className={({ isActive }) =>
                        'nav-link' + (isActive ? " active" : "")}
                    >
                        {t.navServices}
                    </NavLink>

                    <NavLink to="/about" onClick={() => setMenuOpen(false)} className={({ isActive }) =>
                        'nav-link' + (isActive ? " active" : "")}
                    >
                        {t.navAbout}
                    </NavLink>
                </nav>
            </header>

            {/*Main Content*/}
            <main className="main-content">{children}</main>

            {/*Footer*/}
            <footer className="footer">
                <div className="footer-content">

                    <div className="footer-brand">
                        <div className="logo-circle small">愈</div>
                        <div className="footer-brand-text">
                            <h3>{t.brandTitle}</h3>
                            <p>{t.brandSubtitle}</p>
                        </div>
                    </div>

                    <div className="footer-section">
                        <h4>{lang === 'zh' ? '门店信息' : 'Store Location'}</h4>
                        <p>
                            1 Park Road #03-40B <br />
                            People's Park Complex <br />
                            Singapore 059108
                        </p>
                        <p>
                            {lang === 'zh' ? '营业时间' : 'Operating Hours'}:<br />
                            Mon - Sun: 9:30 AM - 9:30 PM
                        </p>
                    </div>

                    <div className="footer-section">
                        <h4>{lang === 'zh' ? '联系我们' : 'Contact Us'}</h4>
                        <p><strong>{lang === 'zh' ? '电话' : 'Phone'}</strong> : +65 83339889</p>
                        <p><strong>WhatsApp</strong>
                            <a href={`https://wa.me/6583339889?text=${lang === 'zh'
                                ? encodeURIComponent('您好，我想预约按摩服务')
                                : encodeURIComponent('Hi, I\'d like to book an appointment')}`}
                                target="_blank" rel="noopener noreferrer">
                                &nbsp;: +65 83339889
                            </a>
                        </p>
                        <p>
                            <a href="tel: 83339889" className="footer-call-btn">
                                {lang === 'zh' ? '立刻拨打' : 'Call Now'}
                            </a>
                        </p>
                    </div>
                </div>
                <div className="footer-bottom">
                    &copy; {new Date().getFullYear()} {t.brandTitle} {t.footerRights}
                </div>
            </footer>

            <div className="floating-actions">
                <a
                    href="tel:83339889"
                    className="fab fab-call"
                    aria-label="Phone">
                    <img src="../images/phone.jpg" alt="Phone" className="fab-icon"></img>

                </a>

                <a
                    href={`https://wa.me/6583339889?text=${lang === 'zh'
                        ? encodeURIComponent('您好，我想预约按摩服务')
                        : encodeURIComponent('Hi, I\'d like to book an appointment.')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="fab fab-whatsapp"
                    aria-label="WhatsApp">
                    <img src="https://i.imgur.com/Gq7GVKT.png" alt="WhatsApp" className="fab-icon"></img>
                </a>

                <a
                    href="https://maps.app.goo.gl/ZTgB1Co5wEMgeYoc7"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="fab fab-maps"
                    aria-label="Google Maps">
                    <img src="../images/map.jpg" alt="Google Maps" className="fab-icon"></img>
                </a>
            </div>
        </div>
    );
}

export default NavFooter;
